import RestService from '../services/rest';

// GET
async function getTimeTrackingReason(reasonId) {
  return RestService.getAuthenticated('timeTrackingReasons/detail', { reasonId });
}

async function getTimeTrackingReasons() {
  return RestService.getAuthenticated('timeTrackingReasons/list/all');
}

async function getTimeTrackingReasonsOptions() {
  return RestService.getAuthenticated('timeTrackingReasons/list/options');
}

// POST
async function createTimeTrackingReason(TimeTrackingReason) {
  return RestService.postAuthenticated('timeTrackingReasons/create', TimeTrackingReason);
}

// PUT
async function updateTimeTrackingReason(TimeTrackingReason) {
  return RestService.putAuthenticated('timeTrackingReasons/update', TimeTrackingReason);
}

async function deleteTimeTrackingReason(reasonId) {
  return RestService.postAuthenticated('timeTrackingReasons/delete', { reasonId });
}

export default {
  createTimeTrackingReason,
  getTimeTrackingReason,
  getTimeTrackingReasons,
  updateTimeTrackingReason,
  deleteTimeTrackingReason,
  getTimeTrackingReasonsOptions,
};
